import { createApp } from "vue";
import App from "./app.vue";

import "@rta/ui";

createApp(App).mount("#app");
